export default __webpack_public_path__ + "static/media/donation-nsaa.1d11f103.png";